import { PopupModule } from '~common-store/modules/popup';
import { Vue, Component } from 'vue-property-decorator';
import { DevicesModule } from '~/store/modules/devices';
import { valueIncludesFilterValue } from '~/helpers';
import ActionReloader from '~common-components/Popup/Common/ActionReloader.vue';
import DumpTemplateHeader from '~/components/Popups/Operations/DumpTemplate/Header.vue';
import DumpTemplateBody from '~/components/Popups/Operations/DumpTemplate/Body.vue';

@Component({
    components: {
        ActionReloader,
        DumpTemplateHeader,
        DumpTemplateBody,
    },
})
export default class DumpPopupMixin extends Vue {
    filePrefix = '';

    get currentGatewayId() {
        return DevicesModule.currentGatewayId;
    }

    formattedDump(dump: string) {
        const formattedDump = this.formatDump(dump);
        return !PopupModule.filterValue
            ? formattedDump
            : formattedDump?.filter(this.filterDump) || [];
    }

    filterDump(line: string) {
        const lineIncludesFilterValue = valueIncludesFilterValue(line);
        return PopupModule.filterIncludesValue ? lineIncludesFilterValue : !lineIncludesFilterValue;
    }

    get fileName() {
        const macAddress = this.currentGatewayId.replace(/:/g, '_');
        return `${this.filePrefix}-${macAddress}.txt`;
    }

    // Format  Dump into an array of strings
    formatDump(dump: string): string[] {
        if (!dump) {
            return ['No dump'];
        }
        // Place some space before this pattern to have more visibility
        dump = dump.replace(/(STAT_)/g, (match) => {
            return '&nbsp &nbsp' + match;
        });

        // Convert in array
        const formattedDump = dump.split(/\n/g).map((line) => {
            // if line is empty, add a line break
            if (line === '') {
                return '<br />';
            }
            // Replace all \s with spaces but not those in tags
            line = line.replace(/(<.*?>)/, (match) => {
                return match.replace(' ', 'SPACE_REPLACE');
            });
            line = line.replace(/\s/g, '&nbsp');
            line = line.replace('SPACE_REPLACE', ' ');
            return line;
        });
        return formattedDump;
    }
}
